/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import DOMPurify from 'dompurify'
import { pagesStatus } from 'reduxModules/pages'
import { pageStateSelector as stateSelector } from 'reduxModules/pages/selectors'
import { pageDispatchers as dispatchers } from 'reduxModules/pages/dispatchers'
import AssetGalleryPropTypes from 'components/generic/AssetsGallery/propTypes'
import withRouterV6 from '../../utils/withRouterV6'
import AssetsGallery from '../generic/AssetsGallery'

import './styles.css'

export class Page extends Component {
  componentDidMount() {
    this.props.loadPage()
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props
    const oldParams = prevProps.params
    if (params.slug && (!oldParams || params.slug !== oldParams.slug))
      this.props.loadPage(params.slug)
  }

  getBody() {
    return { __html: DOMPurify.sanitize(this.props.body) }
  }

  render() {
    if (this.props.status !== pagesStatus.success) return null
    return (
      <div id="Page">
        <h1>{this.props.title}</h1>
        <section id="content">
          {this.props.description && (
            <div className="description">
              {this.props.description}
            </div>
          )}
          {(this.props.photo.medium || this.props.website) && (
            <div
              className={classnames('extras', { '-with-photo': this.props.photo.medium })}
            >
              {this.props.photo.medium && (
                <img src={this.props.photo.medium} role="presentation" alt={this.props.title} />
              )}
              {this.props.website && (
                <a href={this.props.website} target="_blank" rel="noreferrer">{this.props.website}</a>
              )}
            </div>
          )}
          {this.props.body && (
            <div
              className="body formatted"
              dangerouslySetInnerHTML={this.getBody()}
            />
          )}
        </section>
        {this.props.assets && this.props.assets.length > 0 && (
          <AssetsGallery assets={this.props.assets} />
        )}
      </div>
    )
  }
}

Page.propTypes = {
  loadPage: PropTypes.func.isRequired,
  status: PropTypes.string,
  title: PropTypes.string,
  slug: PropTypes.string,
  description: PropTypes.string,
  body: PropTypes.string,
  photo: PropTypes.objectOf(PropTypes.string),
  photoThumbnail: PropTypes.objectOf(PropTypes.string),
  assets: PropTypes.arrayOf(PropTypes.shape(AssetGalleryPropTypes)),

  params: PropTypes.shape({ slug: PropTypes.string })
}

Page.defaultProps = {
  body: '',
  photo: {},
  photoThumbnail: {},
  assets: []
}

export default withRouterV6(connect(stateSelector, dispatchers)(Page))
